import { Flex, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

const FormIconHint = ({ icon, children, isVerified }) => {
  const variant = isVerified ? 'verified' : 'unverified';
  const className = isVerified
    ? 'member-center-profile__verified'
    : 'member-center-profile__unverified';
  return (
    <Flex
      alignItems="baseline"
      justifyContent="flex-end"
      marginTop="5px"
      className={className}
    >
      {icon && (
        <Text variant={variant} marginRight="5px">
          {icon}
        </Text>
      )}
      <Text variant={variant}>{children}</Text>
    </Flex>
  );
};

FormIconHint.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.element,
  isVerified: PropTypes.bool,
};

export default FormIconHint;
